import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 3.7a.7.7 0 0 1 .7-.7h16.6a.7.7 0 0 1 .7.7v10.375h-1.4V8.55H4.4V19.6H14V21H3.7a.7.7 0 0 1-.7-.7V3.7Zm1.4 3.45h15.2V4.4H4.4v2.75Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.308 12.3a.7.7 0 0 1 .495.205l2.227 2.226a.7.7 0 0 1 0 .99l-6.01 6.01a.7.7 0 0 1-.412.2l-2.526.299a.7.7 0 0 1-.777-.778l.299-2.525a.7.7 0 0 1 .2-.413l6.01-6.009a.7.7 0 0 1 .494-.205Zm-5.342 7.033-.166 1.402 1.402-.166 5.343-5.343-1.237-1.236-5.342 5.343Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=EditDateIcon24.js.map